import axios from 'axios';

const mapSearchResults = function(commit, result) {
    var searchResults = result.data.data;
    var resultCount = result.data.meta.total;
    var showMoreUrl = result.data.links.next;
    commit('updateSearchResults', {
        searchResults,
        resultCount,
        showMoreUrl
    });
};

export default {
    namespaced: true,
    state: {
        resultCount: null,
        searchResults: [],
        showMoreUrl: null,
        searching: false,
        query: null,

        nearbyListings: null,
        loadingNearbyListings: false
    },
    mutations: {
        resetSearchResults(state) {
            state.resultCount = null;
            state.searchResults = [];
            state.showMoreUrl = null;
        },
        startSearch(state, query) {
            state.searching = true;
            state.query = query;
        },
        updateSearchResults(
            state,
            { searchResults, resultCount, showMoreUrl }
        ) {
            state.searchResults.push.apply(state.searchResults, searchResults);
            state.resultCount = resultCount;
            state.showMoreUrl = showMoreUrl;
            state.searching = false;
        },
        loadNearbyListings(state) {
            state.loadingNearbyListings = true;
        },
        resetNearbyListings(state) {
            state.nearbyListings = null;
        },
        updateNearbyListings(state, data) {
            state.nearbyListings = data;
            state.loadingNearbyListings = false;
        }
    },
    actions: {
        getSearchResults({ commit }, params) {
            commit('resetSearchResults');
            commit('startSearch', params.q);
            axios
                .get('/listings', { params })
                .then(result => mapSearchResults(commit, result))
                .catch(console.error);
        },
        getMoreResults({ commit, state }) {
            commit('startSearch');
            axios
                .get(state.showMoreUrl)
                .then(result => mapSearchResults(commit, result))
                .catch(console.error);
        },
        getNearbyListings({ commit }) {
            commit('resetNearbyListings');
            commit('loadNearbyListings');
            axios
                .get('/nearby-listings')
                .then(result => {
                    commit('updateNearbyListings', result.data.data);
                })
                .catch(console.error);
        }
    }
};
